import type { CustomIconProps } from '../types';

const TimerCash = ({ width, height }: CustomIconProps): JSX.Element => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ?? '44'}
        height={height ?? '44'}
        viewBox="0 0 44 44"
        fill="none"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19 30.936C22.6762 30.936 25.9643 29.274 28.1538 26.6604V26.6279H28.181C29.9013 24.5596 30.936 21.9006 30.936 19C30.936 12.4079 25.592 7.06397 19 7.06397C12.408 7.06397 7.06401 12.4079 7.06401 19C7.06401 25.5921 12.408 30.936 19 30.936ZM23.1058 31.3383C25.2504 30.625 27.1469 29.3681 28.6318 27.7311H36.5231C36.795 27.7311 37.0154 27.978 37.0154 28.2826V32.7122H23.1058V31.3383ZM19 32C20.0759 32 21.1213 31.8693 22.1212 31.6229V36.3453C22.1212 37.2592 22.7824 38 23.5981 38H36.5231C37.3387 38 38 37.2592 38 36.3453V34.9185H38.0001V32.7122H38V28.2826C38 27.3688 37.3387 26.6279 36.5231 26.6279H29.528C31.083 24.4854 32 21.8498 32 19C32 11.8203 26.1797 6 19 6C11.8203 6 6 11.8203 6 19C6 26.1797 11.8203 32 19 32ZM37.0154 34.9185H23.1058V36.3453C23.1058 36.6499 23.3262 36.8969 23.5981 36.8969H36.5231C36.795 36.8969 37.0154 36.6499 37.0154 36.3453V34.9185ZM19.1325 11.6863C19.1325 11.3925 18.8943 11.1543 18.6005 11.1543C18.3067 11.1543 18.0685 11.3925 18.0685 11.6863V18.9988C18.0685 19.1276 18.1152 19.2521 18.2001 19.349L21.0431 22.599C21.2365 22.8202 21.5726 22.8426 21.7938 22.6492C22.0149 22.4557 22.0374 22.1197 21.8439 21.8985L19.1325 18.7989V11.6863Z"
            fill="#414042"
        />
    </svg>
);

export default TimerCash;
